import * as React from "react";
interface props {
  className?: string;
  width?: any;
  height?: any;
}
const SvgIcon = ({ className, width, height }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width || "20"}
    height={height || "21"}
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      fill="#54B317"
      d="M10 2.375a8.125 8.125 0 1 0 8.125 8.125A8.133 8.133 0 0 0 10 2.375m3.567 6.692-4.375 4.375a.626.626 0 0 1-.884 0l-1.875-1.875a.625.625 0 1 1 .884-.884l1.433 1.433 3.933-3.933a.626.626 0 0 1 .884.884"
    ></path>
  </svg>
);

export default SvgIcon;
